export const sectionNoticeSlotsBaseBorderRadius = "0.75rem";
export const sectionNoticeSlotsBaseP = "0.75rem";
export const sectionNoticeSlotsBaseItemSpacing = "0.5rem";
export const sectionNoticeSlotsBaseLayout = "layout-row";
export const sectionNoticeSlotsBaseResizingW = "resizing-w-fill";
export const sectionNoticeSlotsBaseResizingH = "resizing-h-hug";
export const sectionNoticeSlotsContentItemSpacing = "0.25rem";
export const sectionNoticeSlotsContentLayout = "layout-col";
export const sectionNoticeSlotsContentResizingW = "resizing-w-fill";
export const sectionNoticeSlotsContentResizingH = "resizing-h-hug";
export const sectionNoticeSlotsTitleTypography = "400 0.875rem/1.25rem Inter";
export const sectionNoticeSlotsTitleFontWeight = "500";
export const sectionNoticeSlotsTitleResizingW = "resizing-w-fill";
export const sectionNoticeSlotsMessageTypography = "400 0.875rem/1.25rem Inter";
export const sectionNoticeSlotsMessageFontWeight = "500";
export const sectionNoticeSlotsMessageResizingW = "resizing-w-fill";
export const sectionNoticeSlotsIconDensity = "default";
export const sectionNoticeSlotsIconSize = "20dp";
export const sectionNoticeVariantsSemanticNeutralBaseBgColor = "#f1f1f1";
export const sectionNoticeVariantsSemanticNeutralIconColor = "#777777";
export const sectionNoticeVariantsSemanticNeutralIconGlyph = "info";
export const sectionNoticeVariantsSemanticNeutralTitleColor = "#585858";
export const sectionNoticeVariantsSemanticNeutralMessageColor = "#777777";
export const sectionNoticeVariantsSemanticInfoBaseBgColor = "#ecf1fb";
export const sectionNoticeVariantsSemanticInfoIconColor = "#4c74c9";
export const sectionNoticeVariantsSemanticInfoIconGlyph = "info";
export const sectionNoticeVariantsSemanticInfoTitleColor = "#2f54a6";
export const sectionNoticeVariantsSemanticInfoMessageColor = "#4c74c9";
export const sectionNoticeVariantsSemanticErrorBaseBgColor = "#ffecea";
export const sectionNoticeVariantsSemanticErrorIconColor = "#cf484c";
export const sectionNoticeVariantsSemanticErrorIconGlyph = "error";
export const sectionNoticeVariantsSemanticErrorTitleColor = "#a22b32";
export const sectionNoticeVariantsSemanticErrorMessageColor = "#cf484c";
export const sectionNoticeVariantsSemanticWarningBaseBgColor = "#ffeee2";
export const sectionNoticeVariantsSemanticWarningIconColor = "#bf5a00";
export const sectionNoticeVariantsSemanticWarningIconGlyph = "warning";
export const sectionNoticeVariantsSemanticWarningTitleColor = "#924000";
export const sectionNoticeVariantsSemanticWarningMessageColor = "#bf5a00";
export const sectionNoticeVariantsSemanticSuccessBaseBgColor = "#e6f4ed";
export const sectionNoticeVariantsSemanticSuccessIconColor = "#1f8660";
export const sectionNoticeVariantsSemanticSuccessIconGlyph = "check_circle";
export const sectionNoticeVariantsSemanticSuccessTitleColor = "#046545";
export const sectionNoticeVariantsSemanticSuccessMessageColor = "#1f8660";
export const sectionNoticeVariantsSemanticBrandBaseBgColor = "#e2f4f1";
export const sectionNoticeVariantsSemanticBrandIconColor = "#00857c";
export const sectionNoticeVariantsSemanticBrandIconGlyph = "info";
export const sectionNoticeVariantsSemanticBrandTitleColor = "#00635c";
export const sectionNoticeVariantsSemanticBrandMessageColor = "#00857c";
